import React, { useEffect, useState } from 'react';
import InputText from '../../../components/agv-forms-input';
import GenericModal from '../../../components/agv-generic-modal';
import InputRadio from '../../../components/agv-forms-radio';

export default function PackagingCreateModal({
  isOpen,
  setIsOpen,
  createPackaging,
  mainActionIsLoading,
}) {
  const [code, setCode] = useState('');
  const [label, setLabel] = useState('');
  const [itemKey, setItemKey] = useState('');
  const [isActive, setIsActive] = useState('true');
  const isEmpty =
    !code.trim().length || !label.trim().length || !itemKey.trim().length;

  useEffect(() => {
    if (!isOpen) {
      setCode('');
      setLabel('');
      setItemKey('');
      setIsActive('true');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    createPackaging(
      code.trim(),
      label.trim(),
      itemKey.trim(),
      isActive === 'true'
    );
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Créer un type de palette consignée'}
      mainAction={handleSubmit}
      mainActionText={'Créer'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={isEmpty}
    >
      <div className="tw-flex tw-flex-col">
        <InputText
          value={code}
          setValue={setCode}
          fieldTitle={'Code'}
          isRequired
          emptyError={`Le champ "Code" ne peut être vide.`}
          placeholder={'Ex : PAL_NOIR'}
        />
        <InputText
          value={label}
          setValue={setLabel}
          fieldTitle={'Libellé'}
          isRequired
          emptyError={`Le champ "Libellé" ne peut être vide.`}
          style={'tw-mt-4'}
          placeholder={'Ex : Palette noire'}
        />
        <InputText
          value={itemKey}
          setValue={setItemKey}
          fieldTitle={'Référence produit'}
          isRequired
          emptyError={`Le champ "Référence produit" ne peut être vide.`}
          style={'tw-mt-4'}
          placeholder={'Référence produit dans les commandes'}
        />
        <InputRadio
          value={isActive}
          setValue={setIsActive}
          fieldTitle={'Statut'}
          items={[
            { name: 'Actif', value: 'true' },
            { name: 'Inactif', value: 'false' },
          ]}
          style={'tw-mt-4'}
        />
      </div>
    </GenericModal>
  );
}
